/*
 * @Author: 山白 geweijie@cai-inc.com
 * @Date: 2024-08-13 19:16:16
 * @LastEditors: 山白 geweijie@cai-inc.com
 * @LastEditTime: 2024-08-19 19:34:18
 * @FilePath: /zcy-claim-front/src/common/services/unit.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { query, request } from '@/utils/request';
// 保存医院床位、地址等信息
export async function hospitalSave(data) {
  return request(`/zlb/budget/ep/hospital/save`, {
    data: data,
    method: 'POST',
  });
}
// 获取医院地址等信息
export async function getHospitalInfo(params) {
  return request(`/zlb/budget/ep/hospital/info`, {
    method: 'GET',
    params,
  });
}
export async function getOrganizationBusinessDictionary(params) {
  return request(`/api/zlbuser/institution/organizationBusinessDictionary	`, {
    method: 'GET',
    params,
  });
}

// 统一社会信用代码验证
export async function verifyCorporateInfo(params) {
  return query('/zlb/operation/institution/corporate/info', { params });
}
